import {
  updatesCtrl
} from '../admin/modals';
import {
  TerminalCommandModal
} from '../admin/terminal-command-modal.component';
import {
  DebugInfoModal
} from '../admin/debug-info-modal.component';
import ExcellentExport from 'excellentexport';
import {
  DEFAULT_STAT_LIMIT
} from '../common/config';

require('./header.component.scss');

class HeaderController {
  constructor(
    $scope,
    $element,
    $window,
    $timeout,
    CurrentFilterService,
    CurrentModelService,
    $rootScope,
    PermissionService,
    RouterService,
    $cookies,
    $modal,
    FilterEditorService,
    $http,
    CurrentFilterDataService,
    $q,
    FiltersService,
    LocalStorageService,
    FieldsModalService,
    LayoutService,
    ErrorHandlerService,
    AggregateDataService,
    TreeService,
    $templateCache,
    AdminModalService,
    SpecialModalService,
  ) {
    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.LayoutService = LayoutService;
    this.$rootScope = $rootScope;
    this.$window = $window;
    this.currentFilter = CurrentFilterService;
    this.filterBar = CurrentFilterService.filterBar;
    this.CurrentModelService = CurrentModelService;
    this.$rootScope = $rootScope;
    this.permission = PermissionService;
    this.router = RouterService;
    this.AdminModalService = AdminModalService;
    this.AggregateDataService = AggregateDataService;
    this.ErrorHandlerService = ErrorHandlerService;
    this.langClasses = {
      'ru': 'flag-icon-ru',
      'en': 'flag-icon-gb',
      'cn': 'flag-icon-cn',
    };
    this.selectedLang = $cookies.get('django_language') || PermissionService.selectedLang || PermissionService.defaultLang;
    this.$modal = $modal;
    this.$cookies = $cookies;
    this.FilterEditorService = FilterEditorService;
    this.$http = $http;
    this.CurrentFilterDataService = CurrentFilterDataService;
    this.$q = $q;
    this.FiltersService = FiltersService;
    this.CurrentFilterService = CurrentFilterService;
    this.localStorage = LocalStorageService;
    this.FieldsModalService = FieldsModalService;
    this.TreeService = TreeService;
    this.lensePanel = this.$element.find('.lens-panel')[0];
    this.$isShowPanelWords = true;
    this.userNameWaxWidth = 'unset';
    this.$templateCache = $templateCache;
    this.SpecialModalService = SpecialModalService;


    this.$scope.$watch('$ctrl.filter.isChanged', () =>
      this.$timeout(() => this.setUserNameWaxWidth(), 10)
    );

    this.$scope.$on('factsLoaded', () => {
      if (this.filter.toExcel && this.filter.toExcel.convertToExel) {
        const table = document.getElementById('datatable');
        table.innerHTML = table.innerHTML.replace(/<img[^>]+>(<\/img>)?|filter="filter"/g, '');
        const el = document.getElementById('ExcelDownloadItem');
        ExcellentExport.excel(el, 'datatable');
        el.click();
        this.filter.customLimit = this.filter.toExcel.normalLimit;
        delete this.filter.toExcel;
        this.$rootScope.$broadcast('reload');
      }
    });

    this.$rootScope.$on('splitter1Changed', (e, d, d2, name) => {
      this.moveTab();
      this.setUserNameWaxWidth();
    });

    this.$scope.$on('init', e => {
      this.updateMenu();
      this.setUserNameWaxWidth();
    });
  }

  updateMenu() {
    const aList = this.$window.document.querySelectorAll('.sorted-menu-item');
    aList.forEach(a => a.search = this.localStorage.getItem(a.pathname, ''));
  }

  htmlReport() {
    const search = window.location.search + window.location.hash.substring(3);
    let url = `/render/html/${search}${search?'&':'?'}backend=${this.permission.getBackend()}`;
    if (this.currentFilter.filter.isCardFilter && url.indexOf('contentType=dimensioncardfilter') === -1) {
      url = `${url}&contentType=dimensioncardfilter`;
    }
    window.open(url);
  }

  link() {
    alert(this.$templateCache.get('panel_menu.html'));
  }

  get isUserNameWaxWidth() {
    return this.userNameWaxWidth > 25;
  }

  setUserNameWaxWidth() {
    if (!this.adminMenuWidth) {
      this.adminMenuWidth = this.$element.find('.admin-menu').width() -
        (this.$element.find('.lense-admin-width') ? this.$element.find('.lense-admin-width').width() : 0);
    }

    if (this.$isShowPanelWords) {
      let w = 0;
      this.$element.find('.lense-width').each(function() {
        w += this.offsetWidth;
      });
      this.lenseWidth = w;
    }
    const d = 12;
    const spaceWidth = this.lensePanel.offsetWidth - this.lenseWidth - this.adminMenuWidth;
    this.$isShowPanelWords = spaceWidth > d;
    if (this.$isShowPanelWords) {
      this.userNameWaxWidth = (spaceWidth - d);
    }
  }

  get adminTitle() {
    return gettext('Меню') + (this.permission.userName ? ` (${
      this.permission.userName[0].toUpperCase()}${this.permission.userName.substring(1)})` : '');
  }

  get isShowPanelWords() {
    return this.$isShowPanelWords;
  }

  openOptions() {
    this.LayoutService.openOptions();
  }

  get isCardOrDashboard() {
    return this.filter.isDashboard || this.filter.isCard;
  }

  nop(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  openNewDataWindow() {
    this.FieldsModalService.open('CSV');
  }

  moveTab() {
    let left = $('sc-view').offset().left;
    const winWidth = $(window).width();
    const max_left = 520;
    if (left < max_left) left = max_left;
    $('.lens-panel').css({
      'left': left
    });
    const showScreenPanel = $('.show-screen-panel');
    showScreenPanel.css({
      'right': winWidth - left + 60
    });


    if ($('sc-view').width() < 1100)
      $('.lens-panel .hideable').hide();
    else
      $('.lens-panel .hideable').show();
  }

  openNewWindow() {
    this.router.openNewWindow();
    const urlArr = this.router.search().frameUrl.split('/');
    if (urlArr[0] === 'remote' || urlArr[1] === 'remote') {
      this.router.mode = 'explore';
    }
  }

  downloadZip() {
    const filterUrl = this.CurrentFilterService.filter.url;
    this.CurrentFilterService.filter.url = '/analytics/download/zip/';
    this.zipUrl = this.CurrentFilterService.getReportUrl(this.CurrentFilterService.filter);
    this.CurrentFilterService.filter.url = filterUrl;
  }

  downloadDesktopVideo() {
    const filterUrl = this.CurrentFilterService.filter.url;
    this.CurrentFilterService.filter.url = '/analytics/download/desktop_videos/';
    this.videoUrl = this.CurrentFilterService.getReportUrl(this.CurrentFilterService.filter);
    this.CurrentFilterService.filter.url = filterUrl;
  }

  get isFilterChanged() {
    return this.currentFilter.filter ? this.currentFilter.filter.isChanged : false;
  }

  printContainer() {
    this.LayoutService.printContainer(this.CurrentFilterDataService.filterData.filterData);
  }

  saveAsPicture() {
    this.LayoutService.saveAsPicture(this.CurrentFilterDataService.filterData.filterData,
      message => {
        this.ErrorHandlerService.showErrorMessageBox(gettext('Ошибка при получении изображения'), message, null, true);
      });
  }

  get model() {
    return this.CurrentModelService.model;
  }

  get filter() {
    return this.currentFilter.filter;
  }

  set filter(filter) {
    this.currentFilter.filter = filter;
  }

  reset() {
    this.router.resetFilter();
  }

  debugInfo() {
    this.AdminModalService.debugInfo();
  }

  getLinkToPDF() {
    const timeFrom = this.CurrentFilterService.getTimeFrom();
    const timeTo = this.CurrentFilterService.getTimeTo();
    const hash = window.location.hash.replace('#!/', '');
    return `/analytics/filter/pdf${hash}`;
  }

  terminalCommand(terminalCommandValue, commandText) {
    this.AdminModalService.terminalCommand(terminalCommandValue, commandText);
  }

  saveFilter(asNew) {
    this.FilterEditorService.saveFilter(asNew);
  }

  editFilter() {
    if (this.CurrentFilterService.filter.isCardFilter) return;
    const filter = this.CurrentFilterService.filter.id &&
      this.CurrentFilterService.filter.isAnalyticPolitic ?
      this.FiltersService.findById(this.CurrentFilterService.filter.id) : this.CurrentFilterService.filter;
    this.FilterEditorService.editModal({
      filter: filter,
      asNew: false,
      selectFilter: true,
    });
  }

  updateServer() {
    this.$modal.open({
        templateUrl: 'updatesDialog.html',
        controller: updatesCtrl,
      })
      .result
      .then(result => {
      })
      .catch((err) => {
        console.error(err);
      });
  }

  selectLang(lang) {
    if (lang !== this.$cookies.get('django_language')) {
      const expires = new Date();
      expires.setFullYear(expires.getFullYear() + 100);
      this.$cookies.put('django_language', lang, {
        expires: expires
      });
      location.reload();
    }
  }

  newFilter(type) {
    this.router.isEditDasboard = false;
    if (type === 'deletepolicy') {
      this.SpecialModalService.createDeletePolicy(() => this.router.newFilter(type));
    } else this.router.newFilter(type);
  }

  viewReport() {
    this.router.panel = 'catalog';
    this.$rootScope.$broadcast('resize');
  }

  getEventsLink() {
    const timeFrom = this.CurrentFilterService.getTimeFrom();
    const timeTo = this.CurrentFilterService.getTimeTo();
    return '/analytics/get_events?time_from=' + timeFrom + '&time_to=' + timeTo;
  }

  getEventsFileName() {
    return 'Events.zip';
  }

  get isIncident() {
    return this.permission.admin || (this.permission.incident && ['add_incident', 'change_incident', 'add_incident'].every(
      k => this.permission.incident[k]
    ));
  }

  get isDownloadToExcel() {
    if (!this.filter || !this.currentFilter) return false;
    return ((this.filter.mode === 'stat' ||
          (this.filter.isExplore && this.filter.listType === 'table' && this.permission.fact)) &&
        !this.currentFilter.frameUrl && this.filter.content_type == 'filter' &&
        !this.filter.isCardOrDashboard
      ) ||
      (this.filter.mode === 'reports' && this.hasGridId);
  }

  get hasGridId() {
    return this.filter.url === '/analytics/report/departure_time_report/' ||
      this.filter.url === '/analytics/report/departure_time_report_by_group/' ||
      this.filter.url === '/analytics/report/unproductive_time/' ||
      this.filter.url === '/analytics/report/latecomers/' ||
      this.filter.url === '/analytics/report/tabel/workinghours/' ||
      this.filter.url === '/analytics/report/tabel/activetime/' ||
      this.filter.url === '/analytics/report/tabel/torturernocount/' ||
      this.filter.url === '/analytics/report/tabel/printerusage/' ||
      this.filter.url === '/analytics/report/tabel/extended/' ||
      this.filter.url === '/analytics/report/summary/' ||
      this.filter.url === '/analytics/report/summary_by_group/' ||
      this.filter.url === '/analytics/report/aggregate/index/' ||
      this.filter.url === '/analytics/report/summary_statistic/' ||
      this.filter.url === '/analytics/report/product_time_report/' ||
      this.filter.url === '/analytics/report/facts/' ||
      this.filter.url === '/analytics/report/sites/' ||
      this.filter.url === '/analytics/inventory/devices/' ||
      this.filter.url === '/analytics/inventory/apps/' ||
      this.filter.url === '/analytics/report/anomaly/' ||
      this.filter.url === '/analytics/report/stat/' ||
      this.filter.url === '/analytics/report/stat/daily/' ||
      this.filter.url === '/analytics/report/aggregate/index/?lenta=false' ||
      this.filter.url === '/analytics/inventory/apps_report/' ||
      this.filter.url === '/analytics/report/downtime_report/' ||
      this.filter.url === '/analytics/report/consolidated_tabular_report_by_employees/' ||
      this.filter.url === '/analytics/report/consolidated_tabular_report_by_departments/' ||
      this.filter.url === '/analytics/report/consolidated_tabular_report_by_departments2/';
  }

  download($event) {

    function make_report_name() {
      const default_report_name = 'Stats.xls';
      const iframe = document.getElementById('iframe');
      if (iframe === null) {
        return default_report_name;
      }

      const headerEl = iframe.contentDocument.getElementById('_ReportHeader');
      if (headerEl === null || !headerEl.innerText) {
        return default_report_name;
      }

      let report_name = headerEl.innerText.split('\n', 1)[0].trim();

      const headerPeriodEl = iframe.contentDocument.getElementById('_ReportHeaderPeriod');
      if (headerPeriodEl !== null && headerPeriodEl.innerText) {
        report_name += ' (' + headerPeriodEl.innerText.trim() + ')';
      }

      report_name += '.xls'; // please do not change .xlsx in not working in windows
      return report_name;
    }

    let table;
    let table_id = 'datatable';
    if (this.filter.mode === 'stat' || this.filter.mode === 'explore') {
      table = document.getElementById(table_id);
    } else {
      if (this.hasGridId) {
        table_id = 'grid';
      }
      const htmlTable = document.getElementById('iframe').contentDocument.getElementById(table_id);
      table = htmlTable ? this.createExcelTable(htmlTable) : null;
    }
    if (!table) return true;
    if (this.filter.mode === 'explore' && !(this.filter.toExcel && this.filter.toExcel.convertToExel)) {
      this.filter.toExcel = {
        normalLimit: this.filter.customLimit,
        convertToExel: true,
      };
      if (!this.filter.customLimit) this.filter.limit = 500; // DEFAULT_STAT_LIMIT;
      this.$rootScope.$broadcast('reload');
      return true;
    }
    this.LayoutService.download = true;
    this.$timeout(() => {
      const a = document.createElement('a');
      a.download = make_report_name();
      document.body.appendChild(a);
      ExcellentExport.excel(a, table);

      this.$timeout(() => {
        a.click();
        document.body.removeChild(a);
        this.LayoutService.download = false;
      }, 0);
      return true;
    }, 0);
    return true;
  }

  createExcelTable(table) {
    // drop hidden rows
    if (this.filter.url !== '/analytics/inventory/apps_report/') {
      $(table).find('tr:hidden').attr('excel', false);
    }
    const excelTable = table.cloneNode(true);
    if (excelTable.querySelector('.report-hours-hours')) {
      excelTable.querySelectorAll('.report-hours-hours').forEach(el => {
        el.remove();
      });
    }
    $(excelTable).find('[excel=false]').remove();
    return excelTable;
  }

  // "agent_account@user_name:user_name"
  getIsAgent(exect) {
    let AGENTDIM = 'agent_agent@';
    let USERDIM = 'agent_account@';
    let USERFULLDIM = 'agent_account@';
    if (exect) {
      AGENTDIM = 'agent_agent@computer_name:computer_name';
      USERDIM = 'agent_account@user_name:user_name';
      USERFULLDIM = 'agent_account@full_name:full_name';
    }
    const res = (
        this.filterBar.drilldown[0].indexOf(AGENTDIM) !== -1 ||
        this.filterBar.drilldown[0].indexOf(USERDIM) !== -1 ||
        this.filterBar.drilldown[0].indexOf(USERFULLDIM) !== -1
      ) && this.currentFilter.filter &&
      this.currentFilter.filter.filters &&
      this.currentFilter.filter.filters.some(f => (
        f.dimension.indexOf(AGENTDIM) !== -1 ||
        f.dimension.indexOf(USERDIM) !== -1 ||
        f.dimension.indexOf(USERFULLDIM) !== -1
      ));
    if (!res && !exect && this.currentFilter && this.currentFilter.lastScreenshots) {
      this.stopScreenView();
    }
    return res;
  }

  stopScreenView() {
    this.router.cleanRemoteUsers();
    window.CACHE.reset();
    this.$rootScope.$broadcast('reload');
  }

  connectRemoteUsers() {
    this.AggregateDataService.loadRemoteUsers().then(resp => {
      this.AggregateDataService.allRemoteUsers = resp.data;
      this.AggregateDataService.updateRemoteUsers();
      if (!this.AggregateDataService.remoteUsers || !this.AggregateDataService.remoteUsers.length) {
        this.ErrorHandlerService.showErrorMessageBox(
          gettext('Ошибка'),
          gettext('Не удалось установить связь c агентами'),
          null, true
        );
      } else this.router.setRemoteUsers();
    });
  }

  get isScreenViewSelected() {
    return this.router.isRemoteUsers || this.router.isLastScreenshots;
  }

  openTerminal() {
    this.SpecialModalService.openTerminal();
  }

}

export const HeaderComponent = {
  template: require('./header.component.html'),
  controller: HeaderController,
};



// WEBPACK FOOTER //
// ./src/layout/header.component.js